/**
 * @generated SignedSource<<25340d8c339b5e7f5b777eae40168a5d>>
 * @relayHash 920ecab373cc0053518a2da4f0fffc40
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d987b8e614033adc98c1396fa5e5c9acbee35807c385f4e03875475f2c5790ef

import type { ConcreteRequest } from 'relay-runtime';
export type useUserHasAgentCapabilitiesQuery$variables = {
  cloudId: string;
};
export type useUserHasAgentCapabilitiesQuery$data = {
  readonly atlassianStudio_userSiteContext: {
    readonly userPermissions?: {
      readonly isAbleToCreateAgents: boolean | null;
    } | null;
  } | null;
};
export type useUserHasAgentCapabilitiesQuery = {
  response: useUserHasAgentCapabilitiesQuery$data;
  variables: useUserHasAgentCapabilitiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "AtlassianStudioUserProductPermissions",
      "kind": "LinkedField",
      "name": "userPermissions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isAbleToCreateAgents"
        }
      ]
    }
  ],
  "type": "AtlassianStudioUserSiteContextOutput"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useUserHasAgentCapabilitiesQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "atlassianStudio_userSiteContext",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUserHasAgentCapabilitiesQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "atlassianStudio_userSiteContext",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "920ecab373cc0053518a2da4f0fffc40",
    "id": "d987b8e614033adc98c1396fa5e5c9acbee35807c385f4e03875475f2c5790ef",
    "metadata": {},
    "name": "useUserHasAgentCapabilitiesQuery",
    "operationKind": "query",
    "text": "query useUserHasAgentCapabilitiesQuery(\n  $cloudId: ID!\n) {\n  atlassianStudio_userSiteContext(cloudId: $cloudId) {\n    __typename\n    ... on AtlassianStudioUserSiteContextOutput {\n      userPermissions {\n        isAbleToCreateAgents\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3cbfa7733a3172aa2bea771b8ddef880";

export default node;
